import { query, } from "@lookiero/messaging";
const VIEW_VALIDATION = "view_validation";
const viewValidation = (payload) => ({
    ...query({ name: VIEW_VALIDATION }),
    ...payload,
});
const viewValidationHandler = ({ view, signal }) => async ({ questions, answers }) => view({ questions, answers, signal });
export { VIEW_VALIDATION, viewValidation, viewValidationHandler };
